export default "__VITE_ASSET__cdc29c9f__"